// src/components/preventionOfDataLoss.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaSearch, FaTasks, FaLightbulb } from 'react-icons/fa';
import Footer from './footer';
import './preventionOfDataLoss.css';
import PreventionIcon from '../assets/prevention-icon.svg';
import SubpagesVector from '../assets/subpages-vector.svg';

function PreventionOfDataLoss() {
  const { t } = useTranslation();

  return (
    <div className="cybersecurity-posture-view">
      <div className="gradient-background" />

      <div className="cybersecurity-posture-content">
        {/* HERO WRAPPER */}
        <div className="posture-hero-wrapper">
          <div className="posture-hero-background" />
          <div className="posture-hero-container">
            <div className="posture-hero-content">
              <h1 className="posture-title">
                {t('dataLoss')}
                <img
                  src={PreventionIcon}
                  alt="Data Loss Prevention Icon"
                  className="shield-icon"
                />
              </h1>
              <h1 className="assessment-title">{t('preventionData')}</h1>
              <p className="subtitle">{t('dataLossHeroSubtitle')}</p>
            </div>
          </div>
        </div>

        {/* PROTECTION PHASE SECTION */}
        <div className="critical-phase-section">
          <h2 className="critical-phase-subtitle">
            {t('protectionPhaseSubtitle')}
          </h2>
          <div className="critical-phase-grid">
            {/* Item 1 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaShieldAlt className="critical-phase-icon" />
                <span>{t('automatedSecurityChecks')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('automatedSecurityChecksDesc')}</p>
            </div>
            {/* Item 2 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaSearch className="critical-phase-icon" />
                <span>{t('supplyChainMonitoring')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('supplyChainMonitoringDesc')}</p>
            </div>
            {/* Item 3 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaTasks className="critical-phase-icon" />
                <span>{t('realTimeAlerting')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('realTimeAlertingDesc')}</p>
            </div>
            {/* Item 4 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaLightbulb className="critical-phase-icon" />
                <span>{t('guidedImplementation')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('guidedImplementationDesc')}</p>
            </div>
          </div>
        </div>

        {/* POST-PROTECTION PHASE SECTION */}
        <div className="post-critical-phase-section">
          <img
            src={SubpagesVector}
            alt="Subpages Vector"
            className="post-critical-phase-image"
          />
          <p className="post-critical-phase-text">
            {t('postProtectionPhaseText')}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PreventionOfDataLoss;